import { render, staticRenderFns } from "./TimeoffRemainderSettingHRM.vue?vue&type=template&id=63ff0d96&"
import script from "./TimeoffRemainderSettingHRM.vue?vue&type=script&lang=js&"
export * from "./TimeoffRemainderSettingHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports